import React from 'react';

/**
 * Shared site footer used across all public pages.
 */
function SiteFooter() {
  return (
    <footer className="news-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>DAILY HEALTH</h4>
            <p>Your trusted source for health &amp; wellness journalism</p>
          </div>
          <div className="footer-section">
            <h5>Sections</h5>
            <ul>
              <li><a href="/longevity">Longevity</a></li>
              <li><a href="/nutrition">Nutrition</a></li>
              <li><a href="/research">Research</a></li>
              <li><a href="/mental-health">Mental Health</a></li>
              <li><a href="/prevention">Prevention</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h5>Company</h5>
            <ul>
              <li><a href="/about">About Us</a></li>
              <li><a href="/terms-of-use">Terms of Use</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Daily Health. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
